import { useAuth } from "../hooks/useAuth";
import { useState } from "react";
import { School } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { ContextSwitchModal } from "./ContextSwitchModal";

/** Access-denied recovery opens the same modal as the portal menu, without exposing app-layer UI to auth. */
export function TenantSelector() {
  const { user, generation } = useAuth();
  const [openedAt, setOpenedAt] = useState<number | null>(null);
  if (!user || user.tenants.length < 2) return null;
  return (
    <>
      <Button
        type="button"
        variant="outlineBrand"
        size="touch"
        className="w-full"
        aria-haspopup="dialog"
        onClick={() => setOpenedAt(generation)}
      >
        <School className="size-4" aria-hidden="true" />
        تغییر مدرسه فعال
      </Button>
      {openedAt === generation && (
        <ContextSwitchModal kind="school" onDismiss={() => setOpenedAt(null)} />
      )}
    </>
  );
}
